export default "__VITE_ASSET__CInM7NJU__"